import React from 'react';
import { FlameIcon } from 'lucide-react';
import { Countdown } from './Countdown';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-terracotta text-cream" data-id="element-195" data-mp="3cwhesb62rtgr">
      <div className="mx-auto flex h-10 max-w-6xl items-center justify-center gap-2 px-4 text-center" data-id="element-196" data-mp="37vjwlyl2ezf9">
        <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-197" data-mp="32xrwwie6i90i" />
        <span className="text-xs font-bold uppercase tracking-wider sm:text-sm" data-id="element-198" data-mp="2yveqdrrly72o">
          Oferta termina en
        </span>
        <Countdown variant="bar" data-id="element-199" data-mp="2u456z8wnjzz8" />
      </div>
    </div>;
}